import { store } from "../../../redux/store";
import { addTab, setActiveTab } from "../../../redux/action/tab.action";

let focus = null;
let section = "inventory";
const listeners = new Set();
const sectionListeners = new Set();

export const getItemLocationFocus = () => focus;
export const getInventorySection = () => section;

export const subscribeItemLocationFocus = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const subscribeInventorySection = (listener) => {
  sectionListeners.add(listener);
  return () => sectionListeners.delete(listener);
};

const publish = (next) => {
  focus = next;
  listeners.forEach((listener) => listener(next));
};

export const showInventorySection = (nextSection) => {
  section = nextSection || "inventory";
  sectionListeners.forEach((listener) => listener(section));
};

export const clearItemLocationFocus = () => {
  if (focus == null) return;
  publish(null);
};

const findInventoryMenu = (items) => {
  for (const item of items || []) {
    if (item?.children?.length) {
      const nested = findInventoryMenu(item.children);
      if (nested) return nested;
    }
    const title = String(item?.title || "").trim().toLowerCase();
    if (item?.content === "Inventory" || title === "inventory visibility" || title === "item inventory") {
      return item;
    }
  }
  return null;
};

const openInventoryVisibilityTab = () => {
  const state = store.getState();
  const tabs = state?.tab?.tabs || [];
  const existingIndex = tabs.findIndex(
    (tab) => tab?.content === "Inventory" || String(tab?.title || "").trim().toLowerCase() === "inventory visibility"
  );

  if (existingIndex !== -1) {
    store.dispatch(setActiveTab(existingIndex));
    return;
  }

  const menu = findInventoryMenu(state?.permissions?.navData);
  store.dispatch(addTab(menu ? {
    title: menu.title,
    path: menu.path,
    content: menu.content,
    iconClass: menu.icon || menu.iconClass || "bi bi-eye",
  } : {
    title: "Inventory Visibility",
    path: "/inventory",
    content: "Inventory",
    iconClass: "bi bi-eye",
  }));
};

export const openItemLocationFocus = (nextFocus) => {
  publish(nextFocus && (nextFocus.item || nextFocus.location) ? nextFocus : null);
  showInventorySection("itemLocation");
  openInventoryVisibilityTab();
};

let holdFocus = null;
const holdListeners = new Set();

export const getHoldInventoryFocus = () => holdFocus;

export const subscribeHoldInventoryFocus = (listener) => {
  holdListeners.add(listener);
  return () => holdListeners.delete(listener);
};

const publishHold = (next) => {
  holdFocus = next;
  holdListeners.forEach((listener) => listener(next));
};

export const clearHoldInventoryFocus = () => {
  if (holdFocus == null) return;
  publishHold(null);
};

export const openHoldInventoryFocus = (nextFocus) => {
  const item = String(nextFocus?.item || "").trim();
  publishHold(item ? { item } : null);
  showInventorySection("hold");
  openInventoryVisibilityTab();
};
